var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { v4 as uuidv4 } from 'uuid';
import { ajaxSend, ApiBasePath } from 'api/api';
import { getSocketOrWorker } from 'app/middleware/websocket/socketInterface';
export default class WaitMusicAdapter {
    constructor() {
        this._items = [];
    }
    mapWaitMusicToItem({ uuid, name, original_as_mp3_url, }) {
        return {
            id: uuid || uuidv4(),
            name: name || '',
            url: original_as_mp3_url || '',
        };
    }
    getItemForCallback(id) {
        const items = this._items;
        const item = items.find((item) => item.id === id);
        if (!item) {
            return undefined;
        }
        const _a = item.item, { uuid } = _a, audio = __rest(_a, ["uuid"]);
        return Object.assign(Object.assign({}, audio), { uuid, id: uuid });
    }
    getItemFromURL(url) {
        const items = this._items;
        const { item } = items.find(({ item: { master_file_path } }) => url === master_file_path) || {};
        return item && this.mapWaitMusicToItem(item);
    }
    getFormattedItem(audio) {
        const { uuid: id } = audio;
        const items = this._items;
        const { item } = items.find((item) => item.id === id) || {};
        if (!item) {
            return undefined;
        }
        return this.mapWaitMusicToItem(item);
    }
    getItems() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { wait_music }, } = yield ajaxSend({
                path: '/v1/wait_music',
            });
            const items = wait_music.map(this.mapWaitMusicToItem);
            this._items = items.map(({ id }, index) => ({
                id,
                item: wait_music[index],
            }));
            return items;
        });
    }
    upload(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new FormData();
            data.append('file', file);
            const { data: { relative_uri }, } = yield ajaxSend({
                path: '/private/attachment',
                method: 'POST',
                basePath: ApiBasePath.Files,
                headers: {
                    contentType: 'multipart/form-data',
                },
                data,
            });
            yield ajaxSend({
                path: '/v1/wait_music',
                method: 'POST',
                data: {
                    name: file.name,
                    master_file_path: relative_uri,
                },
            });
            /*
             * /v1/wait_music only queues the upload.
             * We need to listen for a web socket message to know when it's actually uploaded.
             */
            const socketOrWorker = yield getSocketOrWorker();
            yield socketOrWorker.waitForMessage('flow:upload_wait_music_result');
            return relative_uri;
        });
    }
}
